export default "__VITE_ASSET__CyXSKEk9__"